interface BudgetBarProps {
  totalBudget: number;
  totalExpenses: number;
}

export const BudgetBar: React.FC<BudgetBarProps> = ({ totalBudget, totalExpenses }) => {
  // Calculate percentage used (minimum 1% to always show some color)
  const budgetUsedPercentage = totalBudget > 0
    ? Math.max(1, (totalExpenses / totalBudget) * 100)
    : 1;

  // Determine if budget is exceeded
  const isOverBudget = totalExpenses > totalBudget && totalBudget > 0;

  return (
    <div className="relative h-full w-full bg-muted rounded-lg overflow-hidden flex items-center justify-center min-h-[100px] md:min-h-[120px]">
      {/* Colored bar showing used budget */}
      <div
        className={`absolute left-0 top-0 h-full transition-all duration-500 ${
          isOverBudget ? 'bg-red-500' : 'bg-green-500'
        }`}
        style={{ width: `${Math.min(budgetUsedPercentage, 100)}%` }}
      />

      {/* Budget amount centered */}
      <div className="relative z-10 text-center px-2 md:px-4 min-w-0 w-full">
        <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground drop-shadow-sm truncate">
          ${totalBudget.toFixed(2)}
        </div>
        <div className="text-xs md:text-sm text-muted-foreground mt-1 md:mt-2">
          {totalBudget > 0
            ? `${Math.min(budgetUsedPercentage, 100).toFixed(1)}% used`
            : 'No budget set'}
        </div>
      </div>

      {/* Optional: Show over-budget indicator */}
      {isOverBudget && (
        <div className="absolute bottom-1 right-1 md:bottom-2 md:right-2 text-[10px] md:text-xs text-red-600 font-medium bg-white/90 px-1.5 md:px-2 py-0.5 md:py-1 rounded">
          +${(totalExpenses - totalBudget).toFixed(2)} over
        </div>
      )}
    </div>
  );
};
